import { connect } from 'react-redux';
import ThemeSnackbar from './ThemeSnackbar';
import { removePreviewTheme } from 'store/theme';

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(removePreviewTheme());
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  },
});

const mapStateToProps = (state, ownProps) => {
  return {
    open: !!state.theme.previewThemeId,
    proxySnackBarOpen: ownProps.proxySnackBarOpen,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemeSnackbar);
